<template>
  <v-card flat outlined tile>
    <v-card-title v-text="title || 'Tasks'" />

    <v-card-text v-if="tasks.length">
      <task-checkbox v-for="task in tasks" :key="task.id" :task="task">
        <template #title>
          <router-link :to="{ name: 'task', params: { task_id: task.id } }">
            {{ task.title }}
          </router-link>
        </template>
      </task-checkbox>
    </v-card-text>

    <v-card-text v-else>
      No tasks found.
    </v-card-text>
  </v-card>
</template>

<script>
import TaskCheckbox from './TaskCheckbox'
export default {
  name: 'TasksCard',
  props: {
    title: {
      type: String
    },
    tasks: {
      type: Array,
      required: true
    }
  },
  components: {
    TaskCheckbox
  }
}
</script>
